let DEACTIVATE_CUSTOMER_ADMIN_TAB = {
  options: {
    tabName: 'deactivate',
    uri: '/userAccount',
    dataSet: 'deactivateCustomerAdmin'
  },
  columns: [{
    name: 'name',
    label: 'CLASS_NAME_LABEL',
    type: 'table-grid-text-cell'

  }, {
    name: 'email',
    label: 'CLASS_TEACHER_LABEL',
    type: 'table-grid-text-cell'
  }, {
    name: 'checkbox',
    label: 'CLASS_ID_LABEL',
    type: 'table-grid-checkbox-cell'
  }]
};

export
default DEACTIVATE_CUSTOMER_ADMIN_TAB;


// WEBPACK FOOTER //
// ./app/models/deactivateCustomerAdminTab.js